import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MemberProfile, ProfileCommand, loginIdPattern } from '../domain/member-profile';

@Component({ selector: 'app-login-id-editor', imports: [FormsModule], templateUrl: './login-id-editor.component.html' })
export class LoginIdEditorComponent {
  @Input({ required: true }) member!: Readonly<MemberProfile>;
  @Input() busy = false;
  @Input() blocked = false;
  @Output() submitted = new EventEmitter<ProfileCommand>();
  @Output() cancel = new EventEmitter<void>();
  newLoginId = '';
  get loginIdReg() { return loginIdPattern(this.member.loginId); }
  submit(form: NgForm): void {
    if (form.invalid || form.pending || this.busy || this.blocked) return;
    this.submitted.emit({ kind: 'loginId', value: this.newLoginId });
  }
}
